import { render, staticRenderFns } from "./WorkHistoryTable.vue?vue&type=template&id=89eef7aa&scoped=true&"
import script from "./WorkHistoryTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./WorkHistoryTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "@/css/table-to-cards.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./WorkHistoryTable.vue?vue&type=style&index=1&id=89eef7aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89eef7aa",
  null
  
)

export default component.exports